import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

export const UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER =
	'state.actions.update-categories-in-bulk-category-adder.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER' as const;

export type UpdateCategoriesInBulkCategoryAdder = {
	articleId: string;
	categoryIds: CategoryGuid[];
};

export type UpdateCategoriesInBulkCategoryAdderAction = {
	type: typeof UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER;
	payload: UpdateCategoriesInBulkCategoryAdder;
};

export const updateCategoriesInBulkCategoryAdder = (
	payload: UpdateCategoriesInBulkCategoryAdder,
): UpdateCategoriesInBulkCategoryAdderAction => ({
	payload,
	type: UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER,
});
